import { Component, OnInit } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { ReferralDataService } from '../../../services/referral-data.service';
import { SectionsService } from '../../../services/sections.service';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';
import { AllowListAuthStore } from '../../../shared/authorization/allow-list-auth.store';
import { AuthorizeButtonDirective } from '../../../shared/authorization/authorizeButton.directive';
import { ButtonComponent } from '@ppl/ui';
import { ListTableComponent } from '@ppl/ui';
import { PAGE_CONSTANTS } from '../../../shared/constants/page.constants';
import {
  ENROLLMENT_TYPE_BACKEND_MAPPINGS,
  STATIC_DATA,
} from '../../../shared/constants/static-data.constants';
import { SharedDataService } from '../../../shared/services/shared-data-service';
import { ParticipantLeadsListComponent } from '../../participant-leads-list/participant-leads-list.component';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { ListService } from '../../../shared/services/list.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { NotificationService } from '../../../shared/services/notification.service';

@Component({
  selector: 'ppl-provider-enrollment-list',
  standalone: true,
  imports: [
    ListTableComponent,
    NzIconModule,
    NzButtonModule,
    RouterModule,
    NzDropDownModule,
  ],
  providers: [ListService],
  templateUrl: './provider-enrollment-list.component.html',
  styleUrl: './provider-enrollment-list.component.css',
})
export class ProviderEnrollmentListComponent extends ParticipantLeadsListComponent implements OnInit {
  override sharedDataKey: string = STATIC_DATA.SHARED_PROVIDER_ENROLLMENT_DATA;
  override pageId: string = PAGE_CONSTANTS.PROVIDER_ENROLLMENT_DATA_GRID_PAGE;
  providerTypes: any[] = [];


  constructor(
    router: Router,
    sectionService: SectionsService,
    referralDataService: ReferralDataService,
    sharedDataService: SharedDataService,
    authUtility: AuthorizationUtility,
    private leadDetailsService: LeadDetailsService,
    private listService: ListService,
    userService: UserService,
    private storageService: StorageService,
    allowListStore: AllowListAuthStore,
    private notificationService: NotificationService
  ) {
    super(
      router,
      sectionService,
      referralDataService,
      sharedDataService,
      userService,
      authUtility,
      allowListStore
    );
  }

  // Handler for list-table view user events (clicking PPL IDs)
  onViewUserClicked = (payload: any) => {
    this.userService.setViewUserEvent({
      userId: payload.userId,
      isConsumer: payload.isConsumer
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.listService.getProgramTypes(this.programName).subscribe((data: any) => {
      if (data.responsedata) {
        this.providerTypes = data.responsedata.providerTypes;
      }
    })
  }

  override onNewLead(): void {
    this.router.navigate(['/referralLogic']);
    this.sectionService.setFlow('providers');
    this.sectionService.setEnrollmentType(JSON.stringify([]));
    this.referralDataService.clearReferrralData();
    this.storageService.clearStorage();
  }

  onNewEnrollment(type: string) {
    // this.router.navigate([`/home/newEnrollmentForm/${type}`]);
    this.router.navigate(['/newReferral']);
    this.sectionService.setFlow('providerEnrollment');
    this.sectionService.setEnrollmentType(JSON.stringify([ENROLLMENT_TYPE_BACKEND_MAPPINGS[type]]));
    this.userService.setLeadEntry('providerEnrollment');
    this.referralDataService.clearReferrralData();
    this.storageService.clearStorage();
  }

  override rowClicked(rowDetail: any) {
    const program = this.userService.getSelectedProgram();
    this.userService.setLeadEntry('providerEnrollment');
    this.sectionService.setFlow('providerEnrollment');
    this.referralDataService.clearReferrralData();
    this.storageService.clearStorage();

    this.userService.setSelectedLead(rowDetail.provider_id);

    if (this.isReadOnly && (rowDetail.application_status_lkp == 'New Application' || rowDetail.application_status_lkp == 'In Progress')) {
      this.notificationService.error('View Only', 'Cannot open in-progress applications in view-only mode.');
      return;
    }

    const entrollmentType = rowDetail.associationType ? rowDetail.associationType.split(',').map((t: any) => ENROLLMENT_TYPE_BACKEND_MAPPINGS[t.trim()] || ENROLLMENT_TYPE_BACKEND_MAPPINGS['IR']) : [ENROLLMENT_TYPE_BACKEND_MAPPINGS['IR']];

    this.leadDetailsService
      .fetchLeadDetailsApi(
        'providerEnrollment',
        program ? program.program_code : '',
        rowDetail.provider_id
      )
      .subscribe((data: any) => {
        this.sectionService.setEnrollmentType(JSON.stringify(entrollmentType));

        if (
          rowDetail.application_status_lkp == 'New Application' ||
          rowDetail.application_status_lkp == 'In Progress'
        ) {


          this.referralDataService.setReferralDetails(data.responsedata);
          setTimeout(() => {

            this.storageService.setProviderId(data?.responsedata?.basicInfo?.providerId);
            this.storageService.setTrackingNumber(data.responsedata?.basicInfo?.trackingNumber);
            this.storageService.setProviderPPLId(data.responsedata?.basicInfo?.providerPPLId);
            this.sectionService.setFlow('providerEnrollment');
            // const providerTypes = [...new Set(data?.responsedata?.participantAssociations.map((e: any) => ENROLLMENT_TYPE_BACKEND_MAPPINGS[e.providerType]))];

            this.router.navigate(['/newReferral']);
          }, 200);
        } else {
          setTimeout(() => {
            this.storageService.setProviderPPLId(data.responsedata?.basicInfo?.providerPPLId);
            this.router.navigate(['/home/providerEnrollmentList/details/'], { state: { navigateTo: '/home/providerEnrollmentList' } });
          }, 200);
        }
      });
  }
}
